import { get } from 'lodash/fp';

const defaultResultSelector = get(['result']);

export default ({
  fetch,
  flags = ['isLoaded', 'isLoading'],
  resultSelector = defaultResultSelector,
  set,
  start = set,
  success = set,
  fail = set,
}) => {
  const [isLoaded, isLoading] = flags;

  return (...args) =>
    function* () {
      yield start(
        {
          [isLoading]: true,
        },
        ...args,
      );

      try {
        const res = yield fetch(...args);

        yield success(
          {
            result: resultSelector(res),
            error: null,
            [isLoading]: false,
            [isLoaded]: true,
          },
          ...args,
        );

        return res;
      } catch (error) {
        yield fail(
          {
            error,
            [isLoading]: false,
          },
          ...args,
        );

        throw error;
      }
    };
};
